<template>
  <div class="main-content">
    <van-nav-bar
      id="titlebar"
      title="我审批的"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <div class="content">
      <van-tabs v-model:active="active" border>
        <van-tab title="待处理" style="height: 100%">
          <itemView :type="0" />
        </van-tab>
        <van-tab title="已处理" style="height: 100%">
          <itemView :type="1" />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script setup lang="ts">
import itemView from "./item.vue";

const active = ref(0);
// 返回
const onClickLeft = () => {
  window?.flutter_inappwebview?.callHandler("goBackToApp", null);
};
</script>
<style scoped>
.main-content {
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
}

.content {
  flex: 1;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #f6f6f6;
  overflow: hidden;
}
.list {
  width: 100%;
  height: 100%;
}
</style>
